import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../core/services/data/user.service';
import { UtilitiesService } from '../../core/services/utilities.service';
import { SettingsService } from '../../core/services/data/settings.service';
import { ModalService } from '../../core/services/modal.service';
import { VersionCheckService } from '../../core/services/version-check.service';

@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class FooterComponent implements OnInit {
	public user;

	public settings$;

	public version: string;

	constructor(
		private router: Router,
		private uss: UserService,
		private us: UtilitiesService,
		private settingsService: SettingsService,
		private ms: ModalService,
		private vcs: VersionCheckService,
	) {
		this.version = this.vcs.currentVersion;
	}

	ngOnInit() {
		this.uss.fetchUser().then(
			(user) => {
				this.user = true;
			}, () => {
				this.user = null;
			},
		);
	}

	saveUrl(destination) {
		if (destination === 'login') {
			this.us.saveRoute(window.location.pathname);
		}

		this.router.navigate([`/${destination}`]).then();
	}

	contactForm() {
		this.ms.open('contactFormModal');
	}
}
